import { useState } from 'react';
import UserMenu from './UserMenu';
import { IconButton, Popover } from '@mui/material';
import { Person } from '@mui/icons-material';
import { Authorized } from 'lib/auth';

export function NavUser() {
  const [anchorEl, setAnchorEl] = useState<any>(null);

  const handleOpenUserMenu = (event: any) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => setAnchorEl(null)

  return (
    <Authorized>
      <IconButton onClick={handleOpenUserMenu}>
        <Person />
      </IconButton>
      <Popover 
        anchorEl={anchorEl} 
        open={Boolean(anchorEl)} 
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}>
        <UserMenu onClose={handleClose} />
      </Popover>
    </Authorized>
  )
}
